module.exports = __webpack_public_path__ + "img/auth-one-bg.130f09da.jpg";